import ClientsEditorBase from "./ClientsEditorBase.jsx";
import {HasNotifyBaseMixin} from "../../widget/mixins/HasNotifyBaseMixin.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";

export default class ClientNotifyTab extends HasNotifyBaseMixin(ClientsEditorBase) {
  static get $name() {
    return "ClientNotifyTab";
  }

  static get type() {
    return WIDGET_KEYS.clientNotifyTab;
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.clientEditorNotifyGridState;
  }

  get recordType() {
    return "clientId";
  }

  get entityNamePlaceholder() {
    return "client";
  }
}

ClientNotifyTab.initClass();
